import studentRecordService from './StudentRecordService';
import {DIAGNOSTIC_DATA} from '../dummy_data/reports/sample_diagnostic_report';

export function getDiagnosticReport(studentId, selectedLocale) {
  //return Promise.resolve(DIAGNOSTIC_DATA); //NOTE: uncomment to use sample data
  return studentRecordService.getDiagnosticReport(studentId, selectedLocale).then((data) => {
    let pillarStub = {
      phon: {
        id: "phon",
        label: "Phonological Awareness",
      },
      sight: {
        id: "sight",
        label: "High Frequency Words",
      },
      vocab: {
        id: "vocab",
        label: "Vocabulary",
      },
      decode: {
        id: "decoding",
        label: "Decoding",
      },
      tripleL: {
        id: "tripleL",
        label: "Language, Logic & Literacy",
        score: null,
        contents: null, // note: disable tab if no content
      }
    };

    //Map the return values from the skill recommendation for each pillar to the object model the report expects.
    Object.assign(pillarStub.phon,mapSkillToPillar(data.getSkills.phonologicalAwareness,false));
    Object.assign(pillarStub.sight,mapSkillToPillar(data.getSkills.sightRecognition,true));
    Object.assign(pillarStub.vocab,mapSkillToPillar(data.getSkills.vocabulary,false));
    Object.assign(pillarStub.decode,mapSkillToPillar(data.getSkills.decoding,false));

    //TODO: return a leaner object here instead of returning with all these wrappers and unwrapping elsewhere. This data wrangling is supposed to happen here
    let reportObject = {
      data: {
        studentReport: {
          diagnosis: pillarStub
        },
      },
    };
    console.log(reportObject); //leave in for debugging
    return reportObject;
  }, (error) => {
    console.log(error);
    return {
      data: { studentReport: {} }
    };
  });
}

function mapSkillToPillar(inPillar,useExamples){
  let pillar = {};

  const contentsStub = [
    {
      name: "Likely Mastered Skills",
      fields: [],
      resources: []
    },
    {
      name: "Appropriately Challenging Skills",
      fields: [],
      resources: []
    },
    {
      name: "Very Challenging",
      fields: [],
      resources: []
    }
  ];

  pillar.score = inPillar.percentileRank;
  pillar.contents = JSON.parse(JSON.stringify(contentsStub));
  pillar.contents.map((contentItem)=>{
    switch(contentItem.name){
      case "Likely Mastered Skills":
        contentItem.fields = useExamples ?  mapExamples(inPillar.LikelyMastered[0]) : mapSkills(inPillar.LikelyMastered);
        contentItem.resources = mapResources(inPillar.LikelyMastered);
        break;
      case "Appropriately Challenging Skills":
        contentItem.fields = useExamples ?  mapExamples(inPillar.AppropriatelyChallenging[0]) : mapSkills(inPillar.AppropriatelyChallenging);
        contentItem.resources = mapResources(inPillar.AppropriatelyChallenging);
        break;
      case "Very Challenging":
      contentItem.fields = useExamples ?  mapExamples(inPillar.VeryChallenging[0]) : mapSkills(inPillar.VeryChallenging);
      contentItem.resources = mapResources(inPillar.VeryChallenging);
      break;
    }
  });

  return pillar;
}

function mapExamples(inSkills){
  if(inSkills){
    return inSkills.resources.example.map((item)=>{return item.content});
  }else{
    return [];
  }
}

function mapSkills(inSkills){
  return inSkills.map((item)=>{return item.name});
}

function mapResources(inSkill){
  return inSkill.map((skill)=>{
    let resource = {title: skill.name};

    resource.resources = skill.resources.reference.map((resource)=>{
      return(
        {
          typeUrl: resource.resourceIcon,
          brandingUrl: resource.branding,
          resourceUrl: resource.url,
          title: resource.label
        }
      );
    });
    resource.examples = skill.resources.example.map((example)=>{return example.content});
    return resource;
  });
}